export default function ApproveActionIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#D7FFEB" />
      <path
        d="M17.4062 12.9062L11.2188 19.0938L8.125 16.0001M23.875 12.9062L17.6875 19.0938L16.0441 17.4504"
        stroke="#11A75C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
